module.exports = __webpack_public_path__ + "img/bri-icon.86f7845b.png";